import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { UserFacade } from '@app/store/user';
import { filter, map, tap } from 'rxjs';

export const loggedOut = (): CanActivateFn => {
    return () => {
        const router = inject(Router);
        const userFacade = inject(UserFacade);

        return userFacade.loaded$.pipe(
            tap((loaded) => {
                if (loaded === null) {
                    userFacade.getUser();
                }
            }),
            filter((loaded) => loaded !== null),
            map((loaded) => {
                return loaded === false ? true : router.createUrlTree(['/', 'dashboard']);
            }),
        );
    };
};
